import "./App.css";

function App() {
  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif", margin: 0, padding: 0, background: "#0F172A", minHeight: "100vh", color: "white" }}>

      {/* NAV */}
      <nav style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 60px", borderBottom: "1px solid #1E3A5F" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 28 }}>🛡️</span>
          <span style={{ fontSize: 20, fontWeight: "bold", color: "white" }}>ShieldFi</span>
        </div>
        <div style={{ display: "flex", gap: 30, alignItems: "center" }}>
          <a href="#how" style={{ color: "#94A3B8", textDecoration: "none" }}>How it works</a>
          <a href="#stats" style={{ color: "#94A3B8", textDecoration: "none" }}>Stats</a>
          <a href="#about" style={{ color: "#94A3B8", textDecoration: "none" }}>About</a>
          <a href="#faq" style={{ color: "#94A3B8", textDecoration: "none" }}>FAQ</a>
          <a href="https://app.shieldfi.tech" style={{ background: "#2563EB", color: "white", padding: "10px 24px", borderRadius: 8, textDecoration: "none", fontWeight: "bold" }}>
            Launch App →
          </a>
        </div>
      </nav>

      {/* HERO */}
      <section style={{ textAlign: "center", padding: "100px 20px 80px" }}>
        <div style={{ display: "inline-block", background: "#1E3A5F", color: "#60A5FA", padding: "6px 16px", borderRadius: 20, fontSize: 13, marginBottom: 24 }}>
          Live on Base Sepolia Testnet
        </div>
        <h1 style={{ fontSize: 56, fontWeight: 800, margin: "0 0 24px", lineHeight: 1.1 }}>
          DeFi Insurance,<br />
          <span style={{ color: "#2563EB" }}>Powered by AI</span>
        </h1>
        <p style={{ fontSize: 20, color: "#94A3B8", maxWidth: 600, margin: "0 auto 40px", lineHeight: 1.6 }}>
          Protect your DeFi positions with real-time AI risk scoring.
          No KYC. No intermediaries. Automatic payouts on-chain.
        </p>
        <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
          <a href="https://app.shieldfi.tech" style={{ background: "#2563EB", color: "white", padding: "16px 36px", borderRadius: 8, textDecoration: "none", fontWeight: "bold", fontSize: 18 }}>
            Get Coverage →
          </a>
          <a href="https://app.shieldfi.tech" style={{ background: "transparent", color: "white", padding: "16px 36px", borderRadius: 8, textDecoration: "none", fontWeight: "bold", fontSize: 18, border: "1px solid #334155" }}>
            Provide Liquidity
          </a>
        </div>
      </section>

      {/* STATS */}
      <section id="stats" style={{ display: "flex", justifyContent: "center", gap: 40, padding: "60px 20px", flexWrap: "wrap" }}>
        {[
          { value: "$3.5B", label: "DeFi Insurance Market 2025" },
          { value: "2.6%", label: "Base Premium Rate" },
          { value: "Real-time", label: "AI Risk Scoring" },
          { value: "0", label: "KYC Required" },
        ].map((s, i) => (
          <div key={i} style={{ textAlign: "center", background: "#1E293B", padding: "32px 48px", borderRadius: 12, minWidth: 180 }}>
            <div style={{ fontSize: 36, fontWeight: 800, color: "#2563EB" }}>{s.value}</div>
            <div style={{ color: "#94A3B8", marginTop: 8, fontSize: 14 }}>{s.label}</div>
          </div>
        ))}
      </section>

      {/* HOW IT WORKS */}
      <section id="how" style={{ padding: "80px 20px", maxWidth: 900, margin: "0 auto" }}>
        <h2 style={{ textAlign: "center", fontSize: 36, marginBottom: 60 }}>How It Works</h2>
        <div style={{ display: "flex", gap: 30, flexWrap: "wrap", justifyContent: "center" }}>
          {[
            { step: "01", title: "Enter Protocol Address", desc: "Paste the address of the DeFi protocol you want to protect. Our AI instantly scores its risk." },
            { step: "02", title: "Get AI Risk Score", desc: "Real-time risk assessment using Forta Network, DeFiLlama TVL data, and exploit history databases." },
            { step: "03", title: "Buy Coverage", desc: "Pay the premium in ETH. Your policy is minted on-chain immediately. No paperwork, no waiting." },
            { step: "04", title: "Automatic Payout", desc: "If an exploit is verified on-chain, the payout is executed automatically. No claims process." },
          ].map((item, i) => (
            <div key={i} style={{ background: "#1E293B", padding: 32, borderRadius: 12, width: 380 }}>
              <div style={{ color: "#2563EB", fontSize: 13, fontWeight: "bold", marginBottom: 12 }}>STEP {item.step}</div>
              <h3 style={{ fontSize: 20, marginBottom: 12 }}>{item.title}</h3>
              <p style={{ color: "#94A3B8", lineHeight: 1.6, margin: 0 }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* WHY SHIELDFI */}
      <section style={{ padding: "80px 20px", maxWidth: 900, margin: "0 auto" }}>
        <h2 style={{ textAlign: "center", fontSize: 36, marginBottom: 60 }}>Why ShieldFi</h2>
        <div style={{ display: "flex", gap: 20, flexWrap: "wrap", justifyContent: "center" }}>
          {[
            { icon: "🤖", title: "AI-Powered Pricing", desc: "Dynamic premiums based on real-time risk data. Not flat rates." },
            { icon: "⚡", title: "Instant Payouts", desc: "Verified exploits trigger automatic on-chain payments. Minutes, not weeks." },
            { icon: "🔓", title: "No KYC", desc: "Connect your wallet and get covered. Fully permissionless." },
            { icon: "🔍", title: "Fully Transparent", desc: "All contracts are open source and verified on Basescan." },
            { icon: "💧", title: "Earn as LP", desc: "Deposit ETH in the pool and earn a share of all premiums paid." },
            { icon: "🛡️", title: "Audited Contracts", desc: "Smart contracts audited with Slither. Security first." },
          ].map((item, i) => (
            <div key={i} style={{ background: "#1E293B", padding: 28, borderRadius: 12, width: 260, textAlign: "center" }}>
              <div style={{ fontSize: 36, marginBottom: 12 }}>{item.icon}</div>
              <h3 style={{ fontSize: 16, marginBottom: 8 }}>{item.title}</h3>
              <p style={{ color: "#94A3B8", fontSize: 14, lineHeight: 1.6, margin: 0 }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ABOUT */}
      <section id="about" style={{ padding: "80px 20px", maxWidth: 700, margin: "0 auto", textAlign: "center" }}>
        <h2 style={{ fontSize: 36, marginBottom: 24 }}>Who Built This</h2>
        <p style={{ color: "#94A3B8", fontSize: 18, lineHeight: 1.8, marginBottom: 40 }}>
          ShieldFi was built by an independent developer with a background in IT and insurance brokerage.
          The protocol was designed to solve a real gap in the DeFi insurance market: no AI-powered
          dynamic pricing, no automatic claim verification, no permissionless access.
        </p>
        <div style={{ display: "flex", gap: 20, justifyContent: "center", flexWrap: "wrap" }}>
          {[
            { icon: "🔓", text: "Non-custodial — no one can access user funds" },
            { icon: "📖", text: "Fully open source on GitHub" },
            { icon: "✅", text: "Contracts verified on Basescan" },
            { icon: "🔒", text: "Audited with Slither static analysis" },
          ].map((item, i) => (
            <div key={i} style={{ background: "#1E293B", padding: "16px 24px", borderRadius: 10, display: "flex", alignItems: "center", gap: 12, minWidth: 280 }}>
              <span style={{ fontSize: 24 }}>{item.icon}</span>
              <span style={{ color: "#94A3B8", fontSize: 14 }}>{item.text}</span>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" style={{ padding: "80px 20px", maxWidth: 700, margin: "0 auto" }}>
        <h2 style={{ textAlign: "center", fontSize: 36, marginBottom: 60 }}>FAQ</h2>
        {[
          { q: "What is ShieldFi?", a: "ShieldFi is a decentralized insurance protocol for DeFi smart contracts. Users can buy coverage against hacks and exploits, while liquidity providers earn yield by funding the coverage pool." },
          { q: "How is the premium calculated?", a: "The premium is calculated using our AI risk engine: Base Rate (2.6%) × Risk Multiplier × Utilization Factor. The risk multiplier is derived from audit scores, exploit history, TVL stability, and protocol age." },
          { q: "What happens if my protocol gets hacked?", a: "You submit a claim with the exploit transaction hash. Once verified on-chain, the payout is executed automatically to your wallet." },
          { q: "How do I earn as a Liquidity Provider?", a: "Deposit ETH into the coverage pool. You earn 85% of all premiums paid by insured users, proportional to your share of the pool." },
          { q: "Is ShieldFi audited?", a: "Yes. All smart contracts have been analyzed with Slither static analysis. The code is fully open source and verifiable on Basescan." },
        ].map((item, i) => (
          <div key={i} style={{ background: "#1E293B", padding: 28, borderRadius: 12, marginBottom: 16 }}>
            <h3 style={{ fontSize: 18, marginBottom: 12, color: "white" }}>{item.q}</h3>
            <p style={{ color: "#94A3B8", lineHeight: 1.7, margin: 0 }}>{item.a}</p>
          </div>
        ))}
      </section>

      {/* CTA */}
      <section style={{ textAlign: "center", padding: "80px 20px", background: "#1E293B", margin: "60px 0 0" }}>
        <h2 style={{ fontSize: 40, marginBottom: 20 }}>Ready to protect your DeFi?</h2>
        <p style={{ color: "#94A3B8", fontSize: 18, marginBottom: 40 }}>Join the first AI-powered DeFi insurance protocol on Base.</p>
        <a href="https://app.shieldfi.tech" style={{ background: "#2563EB", color: "white", padding: "18px 48px", borderRadius: 8, textDecoration: "none", fontWeight: "bold", fontSize: 20 }}>
          Launch App →
        </a>
      </section>

      {/* FOOTER */}
      <footer style={{ textAlign: "center", padding: "40px 20px", color: "#475569", borderTop: "1px solid #1E3A5F" }}>
        <div style={{ marginBottom: 16 }}>
          <span style={{ fontSize: 20 }}>🛡️</span>
          <span style={{ fontWeight: "bold", color: "#94A3B8", marginLeft: 8 }}>ShieldFi Protocol</span>
        </div>
        <div style={{ display: "flex", gap: 24, justifyContent: "center", marginBottom: 16 }}>
          <a href="https://app.shieldfi.tech" style={{ color: "#475569", textDecoration: "none" }}>App</a>
          <a href="https://api.shieldfi.tech/health" style={{ color: "#475569", textDecoration: "none" }}>API</a>
          <a href="https://sepolia.basescan.org/address/0x5DF8635ffeEc02176284ac5994eDA7A3560bAB8D" style={{ color: "#475569", textDecoration: "none" }}>Contract</a>
        </div>
        <p style={{ margin: 0, fontSize: 13 }}>© 2026 ShieldFi Protocol. Built on Base. Testnet only.</p>
      </footer>

    </div>
  );
}

export default App;